import { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Home, FileText, PlusCircle, Clock, CalendarDays, MoreHorizontal } from 'lucide-react'
import { clsx } from 'clsx'
import { usePermissions } from '../../hooks/usePermissions'
import MoreSheet from './MoreSheet'

interface NavItem {
  name: string
  href: string
  icon: React.ElementType
  module?: string
}

const allNavItems: NavItem[] = [
  { name: 'Home', href: '/dashboard', icon: Home, module: 'pwa_dashboard' },
  { name: 'KPI', href: '/kpi', icon: FileText, module: 'pwa_kpi_hub' },
  { name: 'Submit', href: '/kpi', icon: PlusCircle, module: 'pwa_kpi_submission' },
  { name: 'Attendance', href: '/attendance', icon: Clock, module: 'pwa_attendance' },
  { name: 'Leave', href: '/leave', icon: CalendarDays, module: 'pwa_leave' },
]

export default function MobileBottomNav() {
  const location = useLocation()
  const { canAccessPage } = usePermissions()
  const [moreOpen, setMoreOpen] = useState(false)

  const navItems = allNavItems.filter(item => !item.module || canAccessPage(item.module))

  // Check if current path starts with /kpi to highlight KPI tab
  const isKpiActive = location.pathname.startsWith('/kpi')

  return (
    <>
      <nav className="mobile-bottom-nav">
        {navItems.map((item) => {
          const isActive = item.href === '/kpi'
            ? isKpiActive && location.pathname === '/kpi'
            : location.pathname === item.href ||
              (item.href === '/kpi/mom' && location.pathname.startsWith('/kpi/'))

          const isSubmitButton = item.href === '/kpi/mom'

          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={clsx(
                'mobile-nav-item',
                isSubmitButton && 'mobile-nav-submit',
                isActive && !isSubmitButton && 'mobile-nav-active'
              )}
            >
              {isSubmitButton ? (
                <div className="mobile-nav-submit-icon">
                  <item.icon className="h-6 w-6" />
                </div>
              ) : (
                <>
                  <item.icon className={clsx('h-6 w-6', isActive ? 'text-primary-600' : 'text-gray-400')} />
                  <span className={clsx('text-xs mt-1', isActive ? 'text-primary-600 font-medium' : 'text-gray-500')}>
                    {item.name}
                  </span>
                </>
              )}
            </NavLink>
          )
        })}

        <button
          onClick={() => setMoreOpen(true)}
          className="mobile-nav-item"
          aria-label="More options"
        >
          <MoreHorizontal className="h-6 w-6 text-gray-400" />
          <span className="text-xs mt-1 text-gray-500">More</span>
        </button>
      </nav>

      <MoreSheet isOpen={moreOpen} onClose={() => setMoreOpen(false)} />
    </>
  )
}
